import Content from "../views/contents/content/Home";
import ContentHome from "../views/contents/summary/SummaryContentHome";
import MemberManage from "../views/contents/member/MemberTable";
import GroupList from "../views/contents/group/GroupTable";
import AddGroup from "../views/contents/group/AddGroup";
import ModifyGroup from "../views/contents/group/ModifyGroup";
import Login from "../views/contents/login/Login";
import PwReset from "../views/contents/login/PwReset";
import PwResetCompleted from "../views/contents/login/PwResetCompleted";
import MyPage from "../views/contents/member/MyPage";
import Support from "../views/contents/support/Support";
import StatisticsHome from "../views/contents/statistics/StatisticsHome";
import StatisticsDetail from "../views/contents/statistics/StatisticsDetail";
import FAQHome from "../views/contents/faq/FAQHome";
import FAQDetail from "../views/contents/faq/FAQDetail";
import NoticeHome from "../views/contents/notice/NoticeHome";
import NoticeDetail from "../views/contents/notice/NoticeDetail"
import PushHome from "../views/contents/push/PushHome";
import PushDetail from "../views/contents/push/PushDetail";

export const URL_TYPE = {
    ContentList: '/content',
    Content: '/content/step/:step/day/:day',
    MemberManage: '/manage/member',
    GroupList: '/group',
    GroupDetail: '/group/:groupId',
    AddGroup: '/add/group',
    Statistics: '/statistics',
    StatisticsDetail : '/statistics/detail/:groupId',
    Push: '/push',
    PushDetail: '/push/:pushId/lang/:lang',
    Notice: '/notice',
    NoticeDetail: '/notice/:noticeId/lang/:lang',
    Terms: '/terms',
    MyPage: '/profile',
    FAQ: '/faq',
    FAQDetail: '/faq/:faqId/lang/:lang',

    Login: '/login',
    PwReset: '/password-reset',
    PwResetCompleted: '/password-reset-completed',
    Support: '/support',
}

export const USER_HOME = {
    Admin: {path: URL_TYPE.MemberManage, component: MemberManage},
    LocaleAdmin: {path: URL_TYPE.MemberManage, component: MemberManage},
    GroupAdmin: {path: URL_TYPE.MemberManage, component: MemberManage},
    None: {path: URL_TYPE.Login, component: Login},
}

export const AdminRoutes  = [
    { path: URL_TYPE.Login, component: Login },
    { path: URL_TYPE.ContentList, component: ContentHome },
    { path: URL_TYPE.Content, component: Content },
    { path: URL_TYPE.MemberManage, component: MemberManage },
    { path: URL_TYPE.GroupList, component: GroupList },
    { path: URL_TYPE.AddGroup, component: AddGroup },
    { path: URL_TYPE.GroupDetail, component: ModifyGroup },
    { path: URL_TYPE.MyPage, component: MyPage },
    { path: URL_TYPE.Statistics, component: StatisticsHome },
    { path: URL_TYPE.StatisticsDetail, component: StatisticsDetail },
    { path: URL_TYPE.FAQ, component: FAQHome },
    { path: URL_TYPE.FAQDetail, component: FAQDetail },
    { path: URL_TYPE.Notice, component: NoticeHome },
    { path: URL_TYPE.NoticeDetail, component: NoticeDetail },
    { path: URL_TYPE.Push, component: PushHome },
    { path: URL_TYPE.PushDetail, component: PushDetail },


];

export const LocaleAdminRoutes  = [
    { path: URL_TYPE.Login, component: Login },
    { path: URL_TYPE.MemberManage, component: MemberManage },
    { path: URL_TYPE.GroupList, component: GroupList },
    { path: URL_TYPE.AddGroup, component: AddGroup },
    { path: URL_TYPE.GroupDetail, component: ModifyGroup },
    { path: URL_TYPE.MyPage, component: MyPage },
    { path: URL_TYPE.Statistics, component: StatisticsHome },
    { path: URL_TYPE.StatisticsDetail, component: StatisticsDetail },
    { path: URL_TYPE.Notice, component: NoticeHome },
    { path: URL_TYPE.NoticeDetail, component: NoticeDetail },
    { path: URL_TYPE.Push, component: PushHome },
    { path: URL_TYPE.PushDetail, component: PushDetail },
];

export const GroupAdminRoutes  = [
    { path: URL_TYPE.Login, component: Login },
    { path: URL_TYPE.MemberManage, component: MemberManage },
    { path: URL_TYPE.GroupDetail, component: ModifyGroup },
    { path: URL_TYPE.MyPage, component: MyPage },
    { path: URL_TYPE.StatisticsDetail, component: StatisticsDetail },
];

export const NotAuthenticatedRoutes = [
    { path: URL_TYPE.Support, component: Support },
    { path: URL_TYPE.Login, component: Login },
    { path: URL_TYPE.PwReset, component: PwReset },
    { path: URL_TYPE.PwResetCompleted, component: PwResetCompleted },
];
